var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeSimpleOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5269V21.9019C3.5 22.1339 3.59219 22.3565 3.75628 22.5206C3.92038 22.6847 4.14294 22.7769 4.375 22.7769H23.625C23.8571 22.7769 24.0796 22.6847 24.2437 22.5206C24.4078 22.3565 24.5 22.1339 24.5 21.9019V10.5269L14 3.52686L3.5 10.5269Z",
    stroke: "#333333",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 10.5269L15.9097 16.6519H12.0914L3.5 10.5269",
    stroke: "#333333",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.0268555)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSimpleOpen);
export default __webpack_public_path__ + "static/media/EnvelopeSimpleOpen.e597f93edb34b887a6a78e9f652c1ffc.svg";
export { ForwardRef as ReactComponent };